<div class="grid-1col input-grid-gaps">
    <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
    <app-text-input [form]="form" id="code" [prefix]="prefix"></app-text-input>
    <app-number-input
        [form]="form"
        id="amount"
        [label]="prefix + 'fields.amount'"
        [min]="0"
        [max]="100"
    ></app-number-input>
    <app-switch-input [form]="form" id="included" [prefix]="prefix"></app-switch-input>
</div>
